import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import data from "../assets/banner4.jpg";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<>
				<div className="MainBodySection mb-5">
					<div className="container">
						<div className="row">
							<div className="col-md-12">
								<h3 className="main-section-title">
									NETWORK & INFRASTRUCTURE SERVICES
								</h3>
							</div>

							<div className="col-md-12 bg-surface rounded p-3">
								<h5 className="font-semi-bold text-dim py-3">Growth in the Solution Integration (SI)services market is fueled by the need for seamless business processes across an organization’s complete value chain of customers, partners, suppliers, and employees. BOSTON 's services enable clients to identify, develop, and implement the best fit solutions which are equipped to meet their changing business requirements</h5>
								<img 
									style={{
										width:"100%",
										height:"auto"
									}}
									src={data} 
								/>
								<div>
									<h6 className="font-bold text-light bg-primary rounded p-2 my-3">
										 BOSTON 's Solution Integration services offer to:
									</h6>
									<h5
										style={{
											borderLeft:"5px solid var(--primaryColor)",
											padding: "10px"
										}}
									>
										• Leverage IT investments<br/>
										• Minimize risks<br/>
										• Maximize compatibility<br/>
										• Maximize interoperability
									</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}